import {CONSTANTS} from '@/constants';
import Vue from 'vue'
//import VueLodash from 'vue-lodash'
import miniToastr from 'mini-toastr'
//const options = { name: 'lodash' } // customize the way you want to call it
//Vue.use(VueLodash, options) // options is optional

export const functions = {

    data: function () {
        return {
            throttles: [],
                datepicker_attributes: [
                {
                    dot: 'blue',
                    key: 'today',
                    dates: new Date()
                }
            ],
        };
    },
    computed: {
        client_version: function () {
            return CONSTANTS.CONFIG +'-'+ CONSTANTS.VERSION + '-' + CONSTANTS.BDATE;
        },
        my_id: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            return this.$store.state.user.id;
        },
        is_god: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.role_id & CONSTANTS.R_GOD);
        },
        is_admin: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!((this.$store.state.user.role_id & CONSTANTS.R_ADMIN) || (this.$store.state.user.role_id & CONSTANTS.R_GOD));
        },
        is_agent: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.role_id & CONSTANTS.R_AGENT);
        },
        is_agency: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.role_id & CONSTANTS.R_AGENCY);
        },
        is_agent_or_agency: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!((this.$store.state.user.role_id & CONSTANTS.R_AGENT) || (this.$store.state.user.role_id & CONSTANTS.R_AGENCY));
        },
        is_manager: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.role_id & CONSTANTS.R_MANAGER);
        },
        is_buh: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.role_id & CONSTANTS.R_BUH);
        },
        is_manager_or_buh: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!((this.$store.state.user.role_id & CONSTANTS.R_MANAGER) || (this.$store.state.user.role_id & CONSTANTS.R_BUH));
        },
        is_agent_plus: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.role_id & CONSTANTS.R_PLUS);
        },
        test_account: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.test_account);
        },
        test_account_ed: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.test_account_ed);
        },
        test_account_buh: function() {
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return false;
            return !!(this.$store.state.user.test_account_buh);
        },
        can_view_quota: function() {
            return this.is_manager_or_buh || this.is_agent_plus || this.is_admin;
        },

        newOrdersCountOld: function () {
            if (this.$store.state.status && this.$store.state.status!==null && this.$store.state.status.orders_old && this.$store.state.status.orders_old!==null)
                return this.$store.state.status.orders_old.new;
            else
                return 0;
        },

        ordersInWorkOld: function () {
            if (this.$store.state.status && this.$store.state.status!==null && this.$store.state.status.orders_old && this.$store.state.status.orders_old!==null)
                return this.$store.state.status.orders_old.inwork;
            else
                return 0;
        },

        newOrdersCountNew: function () {
            if (this.$store.state.status && this.$store.state.status!==null && this.$store.state.status.orders_new && this.$store.state.status.orders_new!==null)
                return this.$store.state.status.orders_new.new;
            else
                return 0;
        },

        ordersInWorkNew: function () {
            if (this.$store.state.status && this.$store.state.status!==null && this.$store.state.status.orders_new && this.$store.state.status.orders_new!==null)
                return this.$store.state.status.orders_new.inwork;
            else
                return 0;
        },

        newOrdersCount: function () {
            return this.newOrdersCountOld + this.newOrdersCountNew;
        },

        ordersInWork: function () {
            return this.ordersInWorkOld + this.ordersInWorkNew;
        },


        vouchersInWork: function () {
            if (this.$store.state.status && this.$store.state.status!==null && this.$store.state.status.vouchers && this.$store.state.status.vouchers!==null)
                return this.$store.state.status.vouchers.inwork;
            else
                return 0;
        },


        activeTasksCount: function () {
            if (this.is(this.$store.state.status) && this.is(this.$store.state.status.task) && this.is(this.$store.state.status.task.active))
                return this.$store.state.status.task.active ;
            else
                return 0;
        },
        sleepTasksCount: function () {
            if (this.is(this.$store.state.status) && this.is(this.$store.state.status.task) && this.is(this.$store.state.status.task.sleep))
                return this.$store.state.status.task.sleep ;
            else
                return 0;
        },
        expiredTasksCount: function () {
            if (this.is(this.$store.state.status) && this.is(this.$store.state.status.task) && this.is(this.$store.state.status.task.expired))
                return this.$store.state.status.task.expired ;
            else
                return 0;
        },
        totalTasksCount: function () {
            if (this.is(this.$store.state.status) && this.is(this.$store.state.status.task) && this.is(this.$store.state.status.task.total))
                return this.$store.state.status.task.total ;
            else
                return 0;
        },

        server_version: function () {
            if (this.$store.state.status && this.$store.state.status!==null)
                return this.$store.state.status.version;
            else
                return '---';
        },
        is_prod_server: function () {
            if (this.$store.state.status && this.$store.state.status!==null)
                return this.$store.state.status.config === 'prod';
            else
                return false;
        },
        companyCommission: function () {
            if (this.$store.state.company && this.$store.state.company!==null)
                return this.$store.state.company.procent_commission;
            return 0;
        },

        my_company_title: function () {
            if (this.$store.state.company && this.$store.state.company!==null)
                return this.$store.state.company.title;
            return 0;
        },

        my_company_id: function () {
            if (this.$store.state.company && this.$store.state.company!==null)
                return this.$store.state.company.id;
            return 0;
        },

        myCompanyDoccompanies: function () {
            if (this.$store.state.company && this.$store.state.company!==null)
                return this.$store.state.company.doccompanies;
            return [];
        },

        vouchersPage: function () {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/admin/vouchers';
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/admin/vouchers';
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/vouchers';
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agency/vouchers';
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/buh/vouchers';
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/manager/vouchers';
        },

        ordersPage: function () {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/admin/orders';
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/admin/orders';
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/orders';
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agency/orders';
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/buh/orders';
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/manager/orders';
        },

        bookingsPage: function () {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/manager/bookings';
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/manager/bookings';
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/bookings';
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agency/bookings';
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/manager/bookings';
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/manager/bookings';
        },

        CONSTANTS: function () {
            return CONSTANTS;
        },

        defaultAvatar: function () {
             return "img/avatars/4.jpg";
        },
        myAvatar: function () {
            if (!this.is(this.$store.state.user)) return this.defaultAvatar;
            if (!this.is(this.$store.state.user.image)) return this.defaultAvatar;
            return this.$store.state.user.image;
        },

        inited: function () {
            if (!this.$store.state.authtoken) return true;
            if (!this.$store.state.user || this.$store.state.user===null ) return false;
            //  if (!this.$store.state.company || this.$store.state.company===null ) return false;
            return true;
        },

        location: function () {
            return window.location.href.split('?')[0].split('#')[0];
        },

        current_time:function () {
            return this.$store.state.current_time;
        }
    },
    methods: {
        field_name_for_god: function (str) {
            if (this.is_god) {
                return ' [' + str + ']';
            }
            return ''
        },
        voucherPage: function ($voucher_id) {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/admin/voucher/'+$voucher_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/admin/voucher/'+$voucher_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/voucher/'+$voucher_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agency/voucher/'+$voucher_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/buh/voucher/'+$voucher_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/manager/voucher/'+$voucher_id;
        },

        orderPage: function ($order_id) {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/agent/order/'+$order_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/agent/order/'+$order_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/order/'+$order_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agent/order/'+$order_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/agent/order/'+$order_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/agent/order/'+$order_id;
        },

        bookingPage: function ($booking_id) {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/manager/booking/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/manager/booking/'+$booking_id;
            if ((this.$store.state.user.role_id & CONSTANTS.R_AGENT_PLUS)===CONSTANTS.R_AGENT_PLUS) return '/manager/booking/'+$booking_id;
            if ((this.$store.state.user.role_id & CONSTANTS.R_AGENCY_PLUS)===CONSTANTS.R_AGENCY_PLUS) return '/manager/booking/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/booking/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agent/booking/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/manager/booking/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/manager/booking/'+$booking_id;
        },

        bookingPageEx: function ($booking_id) {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/manager/bookingex/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/manager/bookingex/'+$booking_id
            if ((this.$store.state.user.role_id & CONSTANTS.R_AGENT_PLUS)===CONSTANTS.R_AGENT_PLUS) return '/manager/bookingex/'+$booking_id;
            if ((this.$store.state.user.role_id & CONSTANTS.R_AGENCY_PLUS)===CONSTANTS.R_AGENCY_PLUS) return '/manager/bookingex/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/bookingex/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agent/bookingex/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/manager/bookingex/'+$booking_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/manager/bookingex/'+$booking_id;
        },

        taskPage: function ($task_id) {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if ((this.$store.state.user.role_id & CONSTANTS.R_GOD) ||
                (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) ||
                (this.$store.state.user.role_id & CONSTANTS.R_AGENT) ||
                (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) ||
                (this.$store.state.user.role_id & CONSTANTS.R_BUH) ||
                (this.$store.state.user.role_id & CONSTANTS.R_MANAGER)) return '/panel/task/'+$task_id;
        },

        paymentPage: function ($payment_id) {
            if (!this.$store.state.user || this.$store.state.user===null ) return null;
            if (!this.$store.state.user.role_id || this.$store.state.user.role_id === null) return null;
            if (this.$store.state.user.role_id & CONSTANTS.R_GOD) return '/manager/payment/'+$payment_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_ADMIN) return '/manager/payment/'+$payment_id;
            if ((this.$store.state.user.role_id & CONSTANTS.R_AGENT_PLUS)===CONSTANTS.R_AGENT_PLUS) return '/manager/payment/'+$payment_id;
            if ((this.$store.state.user.role_id & CONSTANTS.R_AGENCY_PLUS)===CONSTANTS.R_AGENCY_PLUS) return '/manager/payment/'+$payment_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENT) return '/agent/payment/'+$payment_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_AGENCY) return '/agent/payment/'+$payment_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_BUH) return '/manager/payment/'+$payment_id;
            if (this.$store.state.user.role_id & CONSTANTS.R_MANAGER) return '/manager/payment/'+$payment_id;
        },


        apiurl: function (method) {
            return this.$store.state.apibaseurl + this.$store.state.authtoken + '/' + method + '/';
        },
        dateM2J: function(isoFormatDateString)
        {
            if (!isoFormatDateString) {
                return isoFormatDateString;
            }
            if (typeof(isoFormatDateString) === 'string') {
                return isoFormatDateString.slice(0, 10);
            }
            return typeof(isoFormatDateString);
        },

        isValidDate: function (d) {
            return d instanceof Date && !isNaN(d);
        },

        /**
         * Convert date from JS object or string to ISO string
         * @param jaDate
         * @returns {*}
         */
        dateToISO: function (jaDate)
        {
            //console.log('dateToISO:', jaDate);
            if (!this.is(jaDate)) {
                //console.log('пизда');
                return null;
            }

            if (this.isValidDate(jaDate) ) {
                let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
                return (new Date(jaDate - tzoffset)).toJSON().slice(0, 10);
            }

            if (typeof(jaDate) === 'string') {
                return jaDate.slice(0, 10);
            }

            //console.log('хуй');
            return null;
        },
        /**
         * Convert date from string to JS object
         * @param jaDate
         * @returns {*}
         */
        parseDate:function (strDate) {
            if (!this.is(strDate)) { return null; }
            if (typeof(strDate) === 'string') {
                return new Date(strDate.slice(0, 10));
            }
            return strDate;
        },
        parseTime:function (strDate) {
            if (!this.is(strDate)) { return null; }
            if (typeof(strDate) === 'string') {
                return strDate.slice(11, 16);
            }
            return strDate;
        },
        parseDateTime:function (strDate) {
            if (!this.is(strDate)) { return null; }
            if (typeof(strDate) === 'string') {
                return new Date(strDate);
            }
            return strDate;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref)
            }
            return null
        },

        validateScopedState(scope, ref) {
            // this.console_log('scope='+ scope+'; ref='+ ref)
            // this.console_log('veeFields = '); this.console_log(this.veeFields)
            // this.console_log('veeFields[scope] = '); this.console_log(this.veeFields['$'+scope])
            if (this.veeFields['$'+scope] && this.veeFields['$'+scope]!==null &&
                this.veeFields['$'+scope][ref] && this.veeFields['$'+scope][ref]!==null &&
                (this.veeFields['$'+scope][ref].dirty || this.veeFields['$'+scope][ref].validated)
            ) {
                //this.console_log('veeFields[scope][ref] = '); this.console_log(this.veeFields['$'+scope][ref])
                return !this.veeErrors.has(ref, scope)
            }
            return null
        },


        /**
         * range()
         *
         * Returns an array of numbers between a start number and an end number incremented
         * sequentially by a fixed number(step), beginning with either the start number or
         * the end number depending on which is greater.
         *
         * @param {number} start (Required: The start number.)
         * @param {number} end (Required: The end number. If end is less than start,
         *  then the range begins with end instead of start and decrements instead of increment.)
         * @param {number} step (Optional: The fixed increment or decrement step. Defaults to 1.)
         *
         * @return {array} (An array containing the range numbers.)
         *
         * @throws {TypeError} (If any of start, end and step is not a finite number.)
         * @throws {Error} (If step is not a positive number.)
         */
        range: function (start, end, step = 1) {

            // Test that the first 3 arguments are finite numbers.
            // Using Array.prototype.every() and Number.isFinite().
            const allNumbers = [start, end, step].every(Number.isFinite);

            // Throw an error if any of the first 3 arguments is not a finite number.
            if (!allNumbers) {
                throw new TypeError('range() expects only finite numbers as arguments.');
            }

            // Ensure the step is always a positive number.
            if (step <= 0) {
                throw new Error('step must be a number greater than 0.');
            }

            // When the start number is greater than the end number,
            // modify the step for decrementing instead of incrementing.
            if (start > end) {
                step = -step;
            }

            // Determine the length of the array to be returned.
            // The length is incremented by 1 after Math.floor().
            // This ensures that the end number is listed if it falls within the range.
            const length = Math.floor(Math.abs((end - start) / step)) + 1;

            // Fill up a new array with the range numbers
            // using Array.from() with a mapping function.
            // Finally, return the new array.
            return Array.from(Array(length), (x, index) => start + index * step);
        },


        formatAge: function(y) {
            return formatAge(y);
        },

        formatNumberRoditelny: function(n) {
            return formatNumberRoditelny(n);
        },

        formatPriceKop: function(x, separator=true) {
            return formatPriceKop(x,separator);
        },

        formatPrice: function(x, separator=true) {
            return formatPrice(x,separator);
        },

        formatPriceInt: function(x) {
            return formatPriceInt(x);
        },


        stripDateMon: function(strDate) {
            if (strDate === null) {
                return '';
            }
            if (typeof(strDate) === 'object') {
                strDate = strDate.toJSON();
            }
            return strDate.slice(0, 7);
        },

        rangePickerState(range) {
            if (!range) {
                return {
                    type: 'is-danger',
                    message: 'Введите диапазон',
                };
            }
            return {
                type: 'is-primary',
                message: '',
            };
        },

        throttle: function (id, delay, func) {
            //console.log('throttle');
            clearTimeout(this.throttles[id]);
            this.throttles[id] = setTimeout(func, delay);
        },

        console_log: function ($p) {
            console.log($p);
        },

        error_log: function ($p) {
            console.error($p);
        },

        formatDate: function(d) {
            return this.printDate(d);
        },

        printDate: function(d) {
            return printDate(d);
        },


        printCurrency: function(s) {
            return printDate(d);
        },

        printDateTime: function(d, seconds=false, decorated=false) {
            return printDateTime(d, seconds, decorated);
        },

        printTimeDate: function(d, seconds=false, decorated=false) {
            return printTimeDate(d, seconds, decorated);
        },

        is: function (o) {
            return (o!==null) && (o!==undefined) && (!!o);
        },

        deleteFromListById: function (objectsList, id) {
            let evens = _.remove(objectsList, function(n) {
                return n.id === id;
            });
            return objectsList;
        },

        backOrRouteTo: function (path) {
            this.$router.back();
            this.$router.push({ path: path})
        },

        bookingInvoiceToPay:function (b) {
            switch (b.status) {
                case CONSTANTS.BOOKING_STATUS_BOOKED:
                case CONSTANTS.BOOKING_STATUS_PAYED:
                    return true;
                default:
                    return false;
            }
        },

        bookingInvoicePayed:function (b) {
            switch (b.status) {
                case CONSTANTS.BOOKING_STATUS_SOLD:
                    return true;
                default:
                    return false;
            }
        },

        bookingBillToPay:function (b) {
            switch (b.status) {
                case CONSTANTS.BOOKING_STATUS_BOOKED:
                    return true;
                default:
                    return false;
            }
        },


        bookingBillPayed:function (b) {
            switch (b.status) {
                case CONSTANTS.BOOKING_STATUS_PAYED:
                case CONSTANTS.BOOKING_STATUS_SOLD:
                    return true;
                default:
                    return false;
            }
        },

        httpPrepare: function () {
            this.$eventHub.$emit('loading_start');
        },

        httpSuccess: function (response, checkResult=false, message=null) {
            this.$eventHub.$emit('loading_end');
            response = response.body;
            if (this.is(response.status) && this.is(response.status.version)) {
                this.$store.commit('setStatus', response.status);
            }
            if (checkResult && response.result!=='success') {
                miniToastr["error"](response.error, 'Операция не выполнена', CONSTANTS.TOAST_ERROR_LIFETIME);
                return null;
            }
            if (message) {
                miniToastr["success"](response.message, message, CONSTANTS.TOAST_SUCCESS_LIFETIME);
            }

            return response;
        },

        httpError: function (error) {
            this.$eventHub.$emit('loading_end');
            this.error_log(error);

            let data = ''
            if (this.is(error.body)) {
                data = error.body;
                data = data.error;
            }

            let text = "status: " + error.status.toString();
            if (error.statusText) { text = text + " (" + error.statusText.toString() + ")"; }
            miniToastr["error"](data, text, 15000);
        },

        httpReset: function () {
            this.$eventHub.$emit('loading_reset');
        },

        setLatest: function(cls, id) {
            return this.$store.commit('setLatest', {cls:cls, id:id})
        },
        isLatest: function(cls, id) {
            return this.$store.state.status.latest[cls] == id;
        },
        loginAs: function (id) {
            this.$eventHub.$emit('loginas', id);
        },

        isFunction: function(x) {
            return (x && x!==null && typeof(x)==='function');
        },

        executeFunction: function(x, param=null, payload=null) {
            //console.log('executeFunction param=', param);
            //console.log('executeFunction payload=', payload);
            if (this.isFunction(x)) x(param, payload);
        },

        openReportWindow: function (text, title, url, print=false) {
            var win = window.open('', '_blank', "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600,top=100,left=100");
            win.document.title = title;
            win.document.write( text );
            //window.open(this.reportInvoiceUrl, '_blank');
        },

        reloadView: function() {
            this.$eventHub.$emit('reload_view');
        },

        notifyError: function(text, title) {
            miniToastr["error"](text, title, 15000);
        },

        notifySuccess: function(text, title) {
            miniToastr["success"](text, title, 15000);
        },

        notifyInfo: function(text, title) {
            miniToastr["info"](text, title, 15000);
        },

        findElementByID: function (array, id) {
            let ra = array.filter((el)=>el.id==id);
            if (!ra.length) {
                return null;
            }
            return ra[0];
        }
    },

    notifications: {
        showHttpErrorMessage:
            {
                type: 'error',
                title: 'Произошла ошибка выполнения операции загрузки данных с сервера',
                message: 'Произошла ошибка выполнения операции загрузки данных с сервера'
            },
    },

}
